import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { each } from 'lodash';
import { ProgressBar } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import Pusher from '../../../../components/pusher';
import NumberDisplay from '../../../../components/number-display';
import ConfirmButton from '../../../../components/confirm-button';

class SubmitProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      done: false,
      current: 0,
      currentSuccess: 0,
      currentError: 0,
    };
    this.onProgress = this.onProgress.bind(this);
  }

  onProgress(e) {
    const { data, searchId } = e;
    if (data && searchId === this.props.searchId) {
      let { currentError, currentSuccess, current } = this.state;
      let done = false;

      each(data, (datum) => {
        if (datum.done) {
          done = true;
        } else if (datum.success === false || datum.hasSucceed === false) {
          currentError += 1;
          current += 1;
          this.props.onProgress(datum);
        } else if (datum.success) {
          currentSuccess += 1;
          current += 1;
          this.props.onProgress(datum);
        }
      });

      if (done) {
        this.setState({ done: true });
        this.props.onDone();
      } else {
        this.setState({ done, currentSuccess, current, currentError });
      } 
    }
  }


  render() {
    const { total, isAccount } = this.props;
    const { done, current, currentSuccess, currentError } = this.state;
    // const percentage = total ? current / total : 0;
    const successPercentage = total ? currentSuccess / total : 0;
    const errorPercentage = total ? currentError / total : 0;

    const stats = (
      <p>
        <Fa name={(!done ? 'spinner' : 'check-circle')} className={(!done ? 'text-muted' : 'text-success')} spin={!done} />
        {' '}
        <span className="">{(done ? 'Proccessed' : 'Proccessing')}: <strong><NumberDisplay value={current} precision={0} /></strong> of <strong><NumberDisplay value={total} precision={0} suffix={isAccount ? 'account' : 'opportunity'} suffixIsUnit /></strong></span>
        {' | '}
        <span className="text-danger">Error: <strong><NumberDisplay value={currentError} precision={0} /></strong></span>
        {' | '}
        <span className="text-success">Success: <strong><NumberDisplay value={currentSuccess} precision={0} /></strong></span>
      </p>
    );

    return (
      <div>
        <Pusher
          event="historyRun"
          handler={this.onProgress}
        />
        <div>
          {!done &&
            <div>
              {stats}
              <ProgressBar>
                <ProgressBar active bsStyle="danger" now={(errorPercentage * 100)} key="error" />
                <ProgressBar striped bsStyle="success" now={(successPercentage * 100)} key="success" />
              </ProgressBar>
            </div>
          }
          {done &&
            <div className="clearfix">
              <div className="pull-left">
                {stats}
              </div>
              <div className="pull-right">
                <ConfirmButton size="sm" onConfirm={this.props.onConfirm}>
                  <Fa name="refresh" /> Reset Search
                </ConfirmButton>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}


SubmitProgress.propTypes = {
  searchId: PropTypes.string.isRequired,
  total: PropTypes.number,
  onDone: PropTypes.func,
  onProgress: PropTypes.func,
  onConfirm: PropTypes.func,
  isAccount: PropTypes.bool,
};
SubmitProgress.defaultProps = {
  total: 0,
  onDone: () => {},
  onProgress: () => {},
  onConfirm: () => {},
  isAccount: false,
};
SubmitProgress.contextTypes = {
};


export default SubmitProgress;